import React, { PropTypes } from 'react';

const AddButton = ({ toggle, hasGroups }) => (
  <div>
    <button className="btn btn-primary" onClick={toggle}>
      { hasGroups? "Create a New Focus Group" : "Create a Focus Group" }
    </button>
  </div>
);

AddButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  hasGroups: PropTypes.bool.isRequired,
};

export default AddButton;



// WEBPACK FOOTER //
// ./focus_groups/components/add_button.jsx